export class VoucherTag {
  voucherTagId!: number
  name!: string
}
